export interface TranscriptCustomizePanelProps {
  onBack?: () => void;
}

export enum TranscriptContextualMenuSubPanel {
  NONE = 'none',
  FONT = 'font',
  TRANSCRIPT_BACKGROUND_COLOR = 'transcript-background-color',
  SENTENCE_TEXT_COLOR = 'sentency-text-color',
  ACTIVE_WORD_TEXT_COLOR = 'active-word-text-color',
  SENTENCE_TEXT_OUTLINE_COLOR = 'sentency-text-outline-color',
  ACTIVE_WORD_TEXT_OUTLINE_COLOR = 'active-word-text-outline-color',
  TRANSCRIPT_SHADOW_COLOR = 'transcript-shadow-color',
}
